(() => {
  if (customElements.get('sayuri-review-carousel')) return;
  customElements.define('sayuri-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sayuri-rv-track');
      this.cards = Array.from(this.querySelectorAll('.sayuri-rv-card'));
      this.dots = Array.from(this.querySelectorAll('.sayuri-rv-dot'));
      if (!this.track || !this.cards.length) return;
      this.index = Math.min(1, this.cards.length - 1);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
      this.addEventListener('mouseenter', () => this.pause(), options);
      this.addEventListener('mouseleave', () => this.play(), options);
      this.addEventListener('focusin', () => this.pause(), options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.play(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.viewport = this.track.parentElement;
      this.viewport.tabIndex = 0;
      this.viewport.setAttribute('aria-label', 'レビューを左右にスワイプして表示');
      this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      this.viewport.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        if (event.pointerType === 'mouse') event.preventDefault();
        this.pause();
        this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, dx:0, axis:null};
        this.viewport.setPointerCapture(event.pointerId);
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 7) drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.axis !== 'x') return;
        event.preventDefault();
        drag.dx = dx;
        this.classList.add('is-dragging');
        this.track.style.transform = `translateX(${this.offset + dx}px)`;
      }, options);
      const finish = event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        this.drag = null;
        this.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (event.type === 'pointerup' && drag.axis !== 'y' && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.goTo(this.index + (dx < 0 ? 1 : -1));
        else this.render();
        if (!this.matches(':hover') && !this.contains(document.activeElement)) this.play();
      };
      ['pointerup','pointercancel','lostpointercapture'].forEach(name => this.viewport.addEventListener(name, finish, options));
      this.observer = new ResizeObserver(() => this.render());
      this.observer.observe(this);
      requestAnimationFrame(() => this.render());
      this.play();
    }
    goTo(index) {
      this.index = (index + this.cards.length) % this.cards.length;
      this.render();
    }
    render() {
      const active = this.cards[this.index];
      const viewport = this.track.parentElement;
      const offset = active.offsetLeft - (viewport.clientWidth - active.offsetWidth) / 2;
      this.offset = -offset;
      this.track.style.transform = `translateX(${this.offset}px)`;
      this.cards.forEach((card, index) => card.classList.toggle('is-active', index === this.index));
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    pause() { clearInterval(this.timer); }
    play() {
      this.pause();
      if (!this.drag && this.cards.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.goTo(this.index + 1), 4500);
      }
    }
    disconnectedCallback() { this.pause(); this.events?.abort(); this.observer?.disconnect(); }
  });
})();
